<template>
  <div class="heart-analyzer dgs heart grid-gua paper-grain" data-product="heart">
    <div class="sheet">

      <!-- 版头 -->
      <div class="hh">
        <div class="seal">心</div>
        <div class="name">心动吗</div>
        <div class="sub">一张照片 · 读出他对你的态度</div>
        <div class="tagline">从一张合照里，看出他是不是喜欢你，<br>他的付出欲望有多少。</div>
        <div class="view-demo" @click="showImage = true">点此查看购买后展示图 →</div>

        <div v-if="showImage" class="modal" @click="showImage = false">
          <img :src="require('@/assets/idshow.jpg')" class="modal-image" @click.stop>
        </div>
      </div>

      <div class="main-content">
        <!-- 上传区 -->
        <div v-if="!analysisResults" class="upload-section">

          <div class="uploader">
            <div class="cam">&#128247;</div>
            <label for="file-upload" class="file-upload-btn">上传一张双人照</label>
            <input id="file-upload" type="file" @change="handleFileUpload" accept="image/*" style="display: none;" />
            <div class="hint">支持二人照 / 三人照 · 不同时期照可看感情变化</div>
          </div>

          <div v-if="imageUrl" class="preview-section">
            <img :src="imageUrl" alt="预览图片" class="preview-image" />
          </div>

          <input v-model="name" placeholder="给照片起个名字（标记用）" class="control name-input" />

          <div class="action-buttons">
            <button @click="gotoPay" :disabled="!imageUrl" class="analysis-btn btn btn-seal btn-block">开始分析  ¥5.20</button>
            <button @click="goToList" class="list-btn btn btn-ghost btn-block">查看购买记录</button>
          </div>

          <div v-if="!analysisResults" class="additional-info">
            <div class="card">
              <div class="card-title"><span class="dot"></span>能读出什么</div>
              <div class="u-row"><span class="mark">壹</span><span>他此刻对你是不是真的喜欢</span></div>
              <div class="u-row"><span class="mark">贰</span><span>他的付出欲望高还是低（急不急）</span></div>
              <div class="u-row"><span class="mark">叁</span><span>两个人里，谁更喜欢对方</span></div>
            </div>

            <div class="card">
              <div class="card-title"><span class="dot"></span>使用说明</div>
              <div class="u-row"><span class="mark">壹</span><span>心动吗是一款基于微表情的情感分析工具，旨在帮助用户了解自己和他人之间的情感状态。</span></div>
              <div class="u-row"><span class="mark">贰</span><span>所有的分析结果代表的是，在拍这张照片前后一段时间内，照片中人对对方和对环境的态度。这种态度是会随着时间改变而改变的。</span></div>
              <div class="u-row"><span class="mark">叁</span><span>上传两张不同时期的合照，还可以看出在不同时期中他对你的感情变化如何。</span></div>
              <div class="u-row"><span class="mark">肆</span><span>上传两张不同人的合照，还可以看出谁更加喜欢你。</span></div>
              <div class="u-row"><span class="mark">伍</span><span>也可以看出，对方在你面前是爱付出，还是求回报。</span></div>
              <div class="u-row"><span class="mark">陆</span><span>单人照在公众号即可免费测试，这里只测试二人照和三人照。</span></div>
              <div class="u-row"><span class="mark">柒</span><span>系统资源有限，计算量庞大，所以可能会稍有延迟，感谢理解。</span></div>
            </div>
          </div>
        </div>

        <!-- 结果区 -->
        <div v-if="analysisResults" class="results-section">
          <div class="preview-section">
            <img :src="'http://www.miaoxingjundd.com/facecache/' + otherResults.path" alt="分析图片" class="preview-image" />
          </div>

          <div class="analysis-results">
            <div class="hres-head">
              <h1>心动吗 · 分析结果</h1>
              <div class="sub">在拍摄这张照片前后一段时间内</div>
            </div>

            <div class="verdict">
              <div class="big">{{ analysisResults.peoplenum }}个人的行动想法与心态</div>
              <div class="d">{{ analysisResults.caiword }}</div>
              <div class="d">{{ analysisResults.yinword }}</div>
            </div>

            <div class="card">
              <div class="dim-title"><span class="dot"></span>两个人在想法和心态上的比较</div>

              <p class="cmp"><strong>1.{{ analysisResults.maxcai }}</strong></p>
              <p class="note-num">注①：主导欲望意味着希望自己在这段关系中有更高的决策地位，如果对方不听他的，他心里就会很难受。如果在交往中，这{{analysisResults.maxcailen}}个人主导欲望一直很强，那么则可以通过适时满足来控制对方的情绪。</p>

              <p class="cmp"><strong>2.{{ analysisResults.mincai }}</strong></p>
              <p class="note-num">注③：这说明这{{analysisResults.mincailen}}个人能从当下环境或者另一个人中获得安全感，而这种安全感也会转化为依赖心理。如果在暧昧期，这{{analysisResults.mincailen}}个人是有着比较强的对对方的依赖心理。可以尝试换个环境，分析双方对人的依赖心理。</p>

              <p class="cmp"><strong>3.{{ analysisResults.maxyin }}</strong></p>
              <p class="note-num">注②：这说明当下的环境可以让这{{analysisResults.maxyinlen}}个人长时间的保持耐心，或者说这{{analysisResults.maxyinlen}}个人在这个环境中更容易接受另一个人的各种要求。</p>

              <p class="cmp"><strong>4.{{ analysisResults.minyin }}</strong></p>
              <p class="note-num">注④：这说明这{{analysisResults.minyinlen}}个人从情绪上来说是相对来说更不喜欢对方的，但如果在3中这{{analysisResults.minyinlen}}个人有安全感而在这里缺失亲密感，则很大概率是因为有心事，玩累了等等自身因素。如果在暧昧期，这{{analysisResults.minyinlen}}个人是不喜欢对方的状态。</p>
            </div>

            <div class="card detail-section">
              <h4>付出欲望</h4>
              <ul>
                <li v-for="(item, index) in analysisResults.giving" :key="'giving'+index"><strong>{{ item }}</strong></li>
              </ul>
              <p class="note-num">注⑤：付出欲望代表了一个人对另一个人的物质付出欲望，两者或者三者中物质欲望最高的那个人是很在意对方如何看自己的。可以从这张照片之后拍的照片中分析查看其付出欲望，付出欲望越高，则说明这个人在对方身上有急于索取的精神上的东西。结合第三点与第四点，可以推断出这个人对对方的态度。不喜欢+低付出欲说明自己的问题导致心态不好。不喜欢+高付出欲会更快地分开。</p>
            </div>

            <div class="card detail-section">
              <h4>回报期望</h4>
              <ul>
                <li v-for="(item, index) in analysisResults.receiving" :key="'receiving'+index"><strong>{{ item }}</strong></li>
              </ul>
              <p class="note-num">注⑥：回报期望对应付出欲望，回报期望越高，越希望从对方身上得到物质的满足。回报期望也代表了心态的稳定性，即汇报期望越高，和对方的情感是稳定的。即便是呈现这个人不喜欢的状态，也不会在很短时间内分开。</p>
            </div>

            <div class="card detail-section">
              <h4>耐心</h4>
              <ul>
                <li v-for="(item, index) in analysisResults.changing" :key="'changing'+index"><strong>{{ item }}</strong></li>
              </ul>
              <p class="note-num">注⑦：耐心代表了这个人在当下的环境和在对方身边时的耐心程度。可以从这张照片之后拍的照片中分析查看其耐心程度，耐心程度越高物质付出越低，耐心程度越低，物质付出越高。</p>
            </div>
          </div>

          <div class="action-buttons">
            <button @click="resetAnalysis" class="reset-btn btn btn-ink btn-block">返回</button>
            <button @click="goToList" class="list-btn btn btn-ghost btn-block">查看购买记录</button>
          </div>
        </div>
      </div>

      <div v-if="showInfoImage" class="modal" @click="hideImage">
        <img src="https://example.com/info-image.jpg" alt="Info" class="modal-image" @click.stop>
      </div>

      <div v-if="isLoading" class="loading-overlay">
        <div class="loading-spinner"></div>
        <p>正在进行分析，请不要关闭或退出页面</p>
        <p>平均每一个人需要4秒钟</p>
      </div>

      <div class="contact-section">
        <img src="@/assets/qrcode2017.jpg" alt="QR Code" class="qrcode">
        <div class="contact-text">如有疑问，请扫二维码联系我们</div>
        <div class="foot">心动吗 · 原生家庭识人术</div>
      </div>
    </div>
  </div>
</template>

<script>
import { areaList } from '@vant/area-data';
import { Toast } from 'vant';
import {getAction,postAction} from '@/api/manage';
import { Dialog } from 'vant';
import wx from 'weixin-jsapi';

export default {
  name: 'heartresult',
  data() {
    return {
      showImage: false,
      imageUrl: null,
      filename: '',
      uploadStatus: null,
      name: '',
      analysisResults: null,
      otherResults: null,
      showInfoImage: false,
      pay: 0,
      isLoading: false,
    };
  },
  computed: {
    userinfoLove() {
      return this.$store.getters.getUserinfoLove || {};
    },
    openid() {
      return this.userinfoLove.jsopenid;
    },
    unionid() {
      // 通过vuex的getters方法来获取state里面的数据
      return this.userinfoLove.unionid;
    },
    code(){
      return this.$route.query.code ? this.$route.query.code : ''
    },
  },
  created() {
    if (this.$route.params.analysisData) {
      this.analysisResults = this.$route.params.analysisData.resword;
      this.otherResults = this.$route.params.analysisData;
    }
  },
  mounted() {
    if(this.isweixin()) {
      if(!this.unionid) {
        if(!this.code) {
          var url = encodeURIComponent(window.location.protocol+"//"+window.location.hostname+ '/heartresult')
          window.location.href=`https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxbb2af162829dc7fe&redirect_uri=${url}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`
      } else {
          this.getJsLogin()
        }
      }
    }
  },
  methods: {
    imageView(){
      ImagePreview({images:['http://www.miaoxingjundd.com/facecache/idshow.jpg'], closeable: true});
    },
    handleFileUpload(event) {
      const files = event.target.files
      if (files.length > 0) {
        const file = files[0]
        this.filename = file.name
        this.previewImage(file)
        this.uploadImage(file)
      }
    },
    previewImage(file) {
      const reader = new FileReader()
      reader.onload = (e) => {
        this.imageUrl = e.target.result
      }
      reader.readAsDataURL(file)
    },
    async uploadImage(file) {
      const formData = new FormData()
      formData.append('pic', file)

      try {
        this.isLoading = true
        const response = await postAction('/pic/face/upload', formData)
        this.isLoading = false
        alert(response.data.msg)
        if(response.data.code == 200) {
          if(!response.data.msg.includes('成功')){
            this.filename = ''
            this.imageUrl = null
          }
        }
      } catch (error) {
        this.isLoading = false
        this.uploadStatus = { type: 'error', message: '上传失败' }
        this.filename = ''
        this.imageUrl = null
      }
    },
    async getRecord() {
      const url = '/ai/face/heartresult'
      try {
        this.isLoading = true
        const resp = await postAction(url, {
          filename: this.filename,
          unionid: this.unionid,
          name: this.name,
          timestamp: new Date().getTime(),
          pay: this.pay
        })
        this.isLoading = false
        if (resp.data.code == 200) {
          this.otherResults = resp.data.msg
          this.analysisResults = resp.data.msg.resword

        }
      } catch (error) {
        console.error('获取分析结果失败:', error)
      }
    },
    // getUserinfo() {
    //   const url = '/xcxlove/userInfo'
    //   postAction(url, {unionid:this.unionid}).then( res => {
    //     if(res.data.code == 200) {
    //       this.userInfo = res.data.msg
    //       this.$store.commit('setUserInfoLove', this.userInfo)
    //       this.getPreluck()
    //       this.getBackluck()
    //     } else if(res.data.code == 400) {
    //       this.$router.push({path:'/loveThreeRegister'})
    //     }
    //   })
    // },
    getJsLogin() {
      if(this.isweixin()) {
        const url = '/user/jslogin'
        postAction(url, {code:this.code}).then( res => {
          if(res.data.code == 200) {
            this.userInfo = res.data.msg
            this.$store.commit('setUserInfoLove', this.userInfo)
          }else{
            this.$router.push({path:'/userRegister'})
          }
        })
      }
    },
    //验证是不是微信
    isweixin(){
        var ua = window.navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
            return true
        } else {
            return false
        }
      },
    //支付接口
    gotoPay() {
      if (!this.name) {
        alert('请输入名称')
        return
      }
      alert('支付后请不要关闭页面，否则无法完整分析结果')
      const vurl = '/pic/lock';
      postAction(vurl).then(vres => {
        if(vres.data.code == 200) {
          const url = '/ai/face/wxpay';
          var that = this;
          getAction(url, { openid: this.openid }).then((res) => {
            if (res.data.code == 200) {
              const result = res.data.msg.result;
              wx.config({
                debug: false, // 这里一般在测试阶段先用true，等打包给后台的时候就改回false,
                appId: result.appId, // 必填，公众号的唯一标识
                timestamp: result.timeStamp, // 必填，生成签名的时间戳
                nonceStr: result.nonceStr, // 必填，生成签名的随机串
                signature: result.paySign, // 必填，签名
                jsApiList: ['checkJsApi', 'chooseWXPay'] // 必填，需要使用的JS接口列表
              });
              wx.ready(() => {
                wx.checkJsApi({
                  jsApiList: ['chooseWXPay'],
                  success: function (res) {
                    wx.chooseWXPay({
                      timestamp: result.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                      nonceStr: result.nonceStr, // 支付签名随机串，不长于 32 位
                      package: result.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
                      signType: result.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                      paySign: result.paySign, // 支付签名
                      success: function (res) {  // 支付成功后的回调函数
                        that.pay = 1;
                        that.getRecord();
                        that.$router.push({ name: 'heartresult', params: { analysisData: that.analysisResults } });
                      },
                      fail: function (res) {
                        alert("支付失败");
                      }
                    });
                  },
                  fail: function (res) {
                    console.log("fail");
                    console.log(res);
                  }
                });
              });
              wx.error(function (err) {
                Toast.fail(err);
              });
            } else {
              Toast.fail(res.data.msg);
            }
          });
        }else{
          if(vres.data.msg) {alert(vres.data.msg)}else{alert('请等待一会再试')}
        }
      })
      
    },
    goToList() {
      this.$router.push({ name: 'heartlist' });
    },
    resetAnalysis() {
      this.imageUrl = null;
      this.filename = '';
      this.name = '';
      this.analysisResults = null;
      this.otherResults = null;
    },
    showImage() {
      this.showInfoImage = true;
    },
    hideImage() {
      this.showInfoImage = false;
    },
  },
  watch: {
    '$route.params.analysisData': function(newData) {
      if (newData) {
        this.analysisResults = newData.resword;
        this.otherResults = newData;
      }
    }
  },
}
</script>

<style scoped>
@import "../style/design-system.css";

.dgs {
  --accent-rose:   #c05a7e;
  --accent-rose-dk:  #9c3f5d;
  --accent-rose-soft: #f2dbe3;
}

/* 版头 */
.hh { padding-top: 8px; text-align: center; }
.hh .seal { width: 56px; height: 56px; font-size: 24px; margin-bottom: 14px; background: var(--accent-rose-dk); }
.hh .name { font-family: var(--f-serif); font-size: 30px; letter-spacing: .2em; }
.hh .sub { margin-top: 10px; font-size: 14px; color: var(--ink-mute); letter-spacing: .08em; }
.hh .tagline { margin-top: 14px; font-size: 13px; color: var(--ink-soft); line-height: 1.7; }
.hh .view-demo {
  margin: 18px auto 0; width: fit-content; padding: 8px 16px;
  font-size: 12px; color: var(--accent-rose-dk);
  border: 1px dashed rgba(156,63,93,.4); border-radius: 999px;
  background: var(--accent-rose-soft); cursor: pointer;
}

/* 上传区 */
.uploader {
  margin-top: 28px; aspect-ratio: 4/3;
  border: 1.5px dashed rgba(27,25,22,.28);
  border-radius: var(--r-l);
  display: flex; flex-direction: column; align-items: center; justify-content: center;
  gap: 10px; background: rgba(255,255,255,.35);
  font-size: 14px; color: var(--ink-mute);
}
.uploader .cam {
  width: 64px; height: 64px; border-radius: 50%;
  background: var(--accent-rose-soft); color: var(--accent-rose-dk);
  display: grid; place-items: center; font-size: 28px;
}
.uploader .file-upload-btn {
  padding: 10px 22px; border-radius: 999px;
  background: var(--accent-rose-dk); color: #fff; font-size: 14px; cursor: pointer;
  box-shadow: 0 6px 16px rgba(156,63,93,.3);
}
.uploader .hint { font-size: 12px; color: var(--ink-faint); }

.main-content .preview-section { margin: 18px 0; text-align: center; }
.preview-image {
  display: block; margin: 0 auto;
  max-width: 100%; max-height: 320px; border-radius: var(--r-l);
  box-shadow: var(--shadow-soft);
}

.name-input {
  width: 100%; margin-top: 18px; padding: 13px 14px; font-size: 16px;
  border: 1px solid rgba(27,25,22,.16); border-radius: var(--r-m);
  background: var(--paper-hi); color: var(--ink);
}
.name-input:focus { outline: none; border-color: var(--accent-rose-dk); box-shadow: 0 0 0 3px rgba(156,63,93,.14); }
.name-input::placeholder { color: var(--ink-faint); }

/* 主按钮 · 玫红 */
.analysis-btn, .analysis-btn:hover { background: var(--accent-rose-dk); box-shadow: 0 6px 16px rgba(156,63,93,.3); }
.analysis-btn:disabled { opacity: .5; cursor: not-allowed; box-shadow: none; }

/* 说明卡片 */
.additional-info .card + .card { margin-top: var(--sp-3); }
.additional-info p { font-size: 13px; color: var(--ink-soft); line-height: 1.7; margin-top: 8px; }
.u-row { display: flex; gap: 8px; margin-top: 10px; font-size: 13px; color: var(--ink-soft); line-height: 1.6; text-align: left; }
.u-row .mark { color: var(--accent-rose-dk); flex: none; width: 16px; font-family: var(--f-serif); }

/* 结果区 */
.hres-head { text-align: center; }
.hres-head h1 { font-family: var(--f-serif); font-size: 24px; letter-spacing: .14em; }
.hres-head .sub { margin-top: 6px; font-size: 12px; color: var(--ink-mute); }

.verdict {
  margin: 18px 0; padding: 20px;
  background: linear-gradient(135deg, rgba(192,90,126,.12), rgba(192,90,126,.04));
  border: 1px solid rgba(156,63,93,.25); border-radius: var(--r-l); text-align: center;
}
.verdict .big { font-family: var(--f-serif); font-size: 20px; color: var(--accent-rose-dk); letter-spacing: .04em; }
.verdict .d { margin-top: 8px; font-size: 13px; color: var(--ink-soft); line-height: 1.7; }

.dim-title { font-family: var(--f-serif); font-size: 16px; letter-spacing: .1em; display: flex; align-items: center; gap: 8px; }
.dim-title .dot, .card-title .dot { width: 6px; height: 6px; background: var(--accent-rose-dk); transform: rotate(45deg); flex: none; }
.card-title .dot { background: var(--accent-rose-dk); }

.cmp { font-size: 14px; color: var(--ink); margin-top: 14px; }
.note-num { font-size: 13px; color: var(--ink-mute); line-height: 1.8; margin-top: 6px; }
.detail-section h4 { font-family: var(--f-serif); font-size: 17px; letter-spacing: .1em; color: var(--accent-rose-dk); }
.detail-section ul { padding-left: 20px; line-height: 1.8; font-size: 14px; color: var(--ink); }
.detail-section li { margin-bottom: 8px; }

/* 结果按钮排 */
.results-section .action-buttons { display: flex; gap: 10px; margin-top: 20px; }
.results-section .action-buttons .btn { flex: 1; }
.reset-btn, .reset-btn:hover { background: transparent; color: var(--ink); box-shadow: inset 0 0 0 1.5px var(--ink-soft); }
.list-btn, .list-btn:hover { background: transparent; color: var(--ink-soft); box-shadow: inset 0 0 0 1.5px var(--ink-soft); }

/* 上传区按钮 */
.upload-section .action-buttons { display: flex; flex-direction: column; gap: 10px; margin-top: 18px; }

/* 弹层 */
.modal {
  position: fixed; top: 0; left: 0; width: 100%; height: 100%;
  background-color: rgba(0,0,0,0.8); display: flex; justify-content: center; align-items: center;
  z-index: 1000;
}
.modal-image { max-width: 90%; max-height: 90%; border-radius: var(--r-m); }

/* 加载遮罩 */
.loading-overlay {
  position: fixed; top: 0; left: 0; width: 100%; height: 100%;
  background-color: rgba(0,0,0,0.5); display: flex; justify-content: center; align-items: center;
  flex-direction: column; z-index: 9999; color: #fff;
}
.loading-spinner {
  width: 50px; height: 50px; border: 3px solid #fff; border-top: 3px solid var(--accent-rose-dk);
  border-radius: 50%; animation: spin 1s linear infinite;
}
@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }

/* 联系区 */
.contact-section { text-align: center; margin-top: 20px; }
.qrcode { width: 20%; height: auto; margin: 0 auto; }
.contact-text { margin-top: 10px; font-size: 14px; color: var(--ink-soft); }
</style>